(() => {
  'use strict';
  const dayMs = 86400000;
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const holidays = new Map();
  const key = date => date.toISOString().slice(0, 10);
  function frenchHolidays(year) {
    if (holidays.has(year)) return holidays.get(year);
    // Gregorian Easter, then the national movable public holidays.
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), base = h + l - 7 * m + 114;
    const easter = new Date(Date.UTC(year, Math.floor(base / 31) - 1, base % 31 + 1, 12));
    const dates = new Set(['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map(value => `${year}-${value}`));
    for (const offset of [1, 39, 50]) dates.add(key(new Date(easter.getTime() + offset * dayMs)));
    holidays.set(year, dates);
    return dates;
  }
  function addBusinessDays(date, count) {
    const result = new Date(date);
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6 && !frenchHolidays(result.getUTCFullYear()).has(key(result))) count--;
    }
    return result;
  }
  function estimate(now = new Date()) {
    // Dispatch is 48 elapsed hours; delivery counting uses the shop's Paris date.
    const dispatch = new Date(now.getTime() + 48 * 60 * 60 * 1000);
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(dispatch).map(part => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
    const start = addBusinessDays(date, 3), end = addBusinessDays(date, 5);
    const full = date => `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
    let label;
    if (start.getUTCFullYear() !== end.getUTCFullYear()) label = `${full(start)} ${start.getUTCFullYear()} - ${full(end)} ${end.getUTCFullYear()}`;
    else if (start.getUTCMonth() !== end.getUTCMonth()) label = `${full(start)} - ${full(end)}`;
    else label = `${start.getUTCDate()} - ${full(end)}`;
    return {start: key(start), end: key(end), label};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {estimate};
  if (typeof window === 'undefined' || !window.customElements || customElements.get('printique-delivery-estimate')) return;
  customElements.define('printique-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.refresh) return;
      this.refresh = () => {
        const target = this.querySelector('[data-delivery-window]');
        if (!target) return;
        const range = estimate();
        const text = `Estimated delivery: ${range.label}`;
        if (target.textContent !== text) target.textContent = text;
        target.dataset.start = range.start;
        target.dataset.end = range.end;
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      this.refresh = null;
    }
  });
})();
